import { render, staticRenderFns } from "./TechnicalParametersComponent.vue?vue&type=template&id=604bc6a4&scoped=true&"
import script from "./TechnicalParametersComponent.vue?vue&type=script&lang=js&"
export * from "./TechnicalParametersComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604bc6a4",
  null
  
)

export default component.exports